module.exports = __webpack_public_path__ + "assets/img/baoche1.edb50e1e.png";